import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as buttonClass from '../../styles/communs/button.module.scss';

const Button = React.forwardRef(({
  children, style, className, onClick, role, id, onKeyDown, onKeyUp, dataCy, ...props
}, ref) => {
  const attr = {};

  if (props['aria-selected']) {
    attr['aria-selected'] = props['aria-selected'];
  }

  if (props['aria-controls']) {
    attr['aria-controls'] = props['aria-controls'];
  }

  return (
    <button
      className={clsx({[buttonClass.button]: className == null, [className]: className !== null})}
      data-cy={dataCy}
      onClick={onClick}
      ref={ref}
      role={role}
      style={style}
      {...attr}
      id={id}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

Button.propTypes = {
  'aria-controls': PropTypes.string,
  'aria-selected': PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  dataCy: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  role: PropTypes.string,
  style: PropTypes.object,
};

export default Button;
